<template>
    <drawer
        class="drawer--events"
        :title="drawerTitle"
        @drawer-closing="onCancel"
    >
        <div class="fe-drawer" @click="closeDropdowns">
            <div class="fe-drawer__panel">
                <flex-event-list
                    :filter="filter"
                    @select="onSelect"
                    @delete="onDelete"
                />
            </div>

            <div class="fe-drawer__panel">
                <flex-event-editor
                    :flex-event="selectedEvent"
                    @update="onUpdate"
                    @cancel="onCancel"
                />
            </div>
        </div>
    </drawer>
</template>

<script>
import { mapState } from 'vuex';

import Drawer from '@/components/shared/drawer/drawer';
import FlexEventEditor from '@/components/events/flex-event-editor';
import FlexEventList from '@/components/events/flex-event-list';
import { FlexEventGroup } from '@/data/data-models';

const CUSTOM_ATTR_NAME = 'flex-event-group';

export default {
    components: {
        Drawer,
        FlexEventEditor,
        FlexEventList,
    },

    data() {
        return {
            filter: '',
            selectedEvent: null,
        };
    },

    computed: {
        ...mapState({
            selectedElements: state => state.page.selectedElements,
        }),

        flexEventGroup() {
            return this.selectedElements[0] && this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME)
                ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME)
                : new FlexEventGroup();
        },

        drawerTitle() {
            return this.selectedElements[0] ? `${ this.selectedElements[0].displayName } Events` : '';
        },
    },

    methods: {
        async onSelect(flexEvent) {
            this.selectedEvent = null;

            // this allows the "created" lifecycle hook logic to run again on the event form components
            // ... which is needed for them to function properly
            await this.$nextTick();
            this.selectedEvent = this.flexEventGroup[flexEvent.trigger].find(fe => fe.id === flexEvent.id);
        },

        onUpdate(flexEvent) {
            this.filter = flexEvent.trigger;
        },

        onDelete(flexEvent) {
            if (this.selectedEvent && this.selectedEvent.id === flexEvent.id) this.selectedEvent = null;

            this.flexEventGroup[flexEvent.trigger] = this.flexEventGroup[flexEvent.trigger].filter(fe => fe.id !== flexEvent.id);
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.flexEventGroup);
        },

        onCancel() {
            this.selectedEvent = null;
        },

        closeDropdowns() {
            this.$root.$emit('flex::dropdown::close');
        },
    },
};
</script>

<style lang="scss" scoped>
.fe-drawer {
    position: relative;
    display: flex;
    height: 100%;

    &__panel {
        &:first-child {
            width: 32%;
        }

        &:last-child {
            overflow: auto;
            max-height: calc(100vh - #{ $drawer-header-height });
            border-left: 1px solid var(--modal-borderColor);
            width: 68%;

            // extra space to prevent the save/cancel buttons from overlapping the content
            // ... and also to prevent the dropdown from going off-screen
            padding-bottom: 200px;
        }
    }
}
</style>
